module.exports = __webpack_public_path__ + "img/ar.98281a5e.svg";